import {
	get,
	post
} from './http.js'; //导入axios实例文件中方法
// let bsae_api = process.env.BASE_API ? './'+process.env.BASE_API :'..' //获取项目api请求地址
//根据id获取用户信息
// export const getUserInfoById = (id) => {
// 	return get(`${bsae_api}/web/user/${id}`); //resfulapi风格
// }
//获取用户信息
export const getUserInfo=(data)=>{
	return get('/V1/Common/Weixin/UserInfo',data)
}
//获取用户信息
export const getAuthorizeUrl=(data)=>{
	return get('/V1/Common/Weixin/AuthorizeUrl',data)
}
//获取用微信分享参数
export const getJsApiConfig=(data)=>{
	return get('/V1/Common/Weixin/JsApiConfig',data)
}
// 注册获取短信验证码
export const getcodes = (data) => {
	return post('/V1/Common/Message/SendPhoneCode', data);
}

// 注册获取邮箱验证码
export const getEmailcodes = (data) => {
	return post('/V1/Common/Message/SendEmailCode', data);
}

// 手机注册提交
export const phoneregister = (data) => {
	return post('/V1/Member/Account/Register', data)
}
//手机号登录
export const phonelogin = (data) => {
	return post('/V1/Member/Account/Login', data)
}

// 忘记密码发送验证码
export const findgetcodes = (data) => {
	return post('/Member/V1/Password/VerificationCode', data)
}
// 邮箱忘记密码发送验证码
export const findgetemailcodes = (data) => {
	return post('/V1/Common/Message/SendPhoneCode', data)
}
//手机提交忘记密码
export const changepassword = (data) => {
	return post('/V1/Member/Account/FindPassword', data)
}

//是否支付成功
export const PayResult = (data) => {
	return post('/V1/Pay/PayResult', data)
}

//申请退款
export const RefundApply = (data) => {
	return post('/v1/Competition/Competition/RefundApply', data)
}

//课程提示
export const getHelps = (data) => {
	return get('/v1/Course/Help/Query', data)
}


// 个人信息
export const getMember = (data) => {
	return get('/V1/Member/Member/Center', data)
}
// 个人中心
export const getuser = (data) => {
	return get('/V1/Member/Member/Info', data)
}
// 修改个人信息
export const changeuser = (data) => {
	return post('/V1/Member/Member/Edit', data)
}
// 修改个人中心密码
export const userchangepassword = (data) => {
	return post('/V1/Member/Account/EditPassword', data)
}

// 阿里云点播
export const getVideo = (data) => {
	return get('/V1/Common/AliyunVod/VideoPlayAuth', data)
}

// 首页 分类
export const getIndexs = (data) => {
	return get('/V1/Website/Home/view', data)
}
// 首页 轮播图
export const getBanner = (data) => {
	return get('/V1/Website/Page/Banner',data)
}


// 方舟资讯 分类
export const newsCategory = (data) => {
	return get('/V1/Content/News/Category', data)
}


// 方舟资讯列表
export const newsList = (data) => {
	return get('/V1/Content/News/QueryPage', data)
}
// 首页 热门资讯
export const HomeArticle = (data) => {
	return get('/V1/Content/News/HomeArticle', data)
}
// 资讯详情
export const newsDetail = (data) => {
	return get('/V1/Content/News/Detail', data)
}
// 资讯详情收藏
export const Collection = (data) => {
	return post('/V1/Content/News/Collection', data)
}

// 资讯查看
export const NewsSee = (data) => {
	return get('/V1/Content/News/ViewQueryPage', data)
}
// 资讯收藏列表
export const NewsCollection = (data) => {
	return get('/V1/Content/News/CollectionQueryPage', data)
}

//获取活动分类
export const PracticeKinds=()=>{
	return get('/V1/Activity/Activity/Category')
}

//获取我参与的活动
export const myParticipationActivity=(data)=>{
	return get('V1/Activity/Activity/MyApplyList',data)
}
export const myShowing=(data)=>{
	return get('v1/Showing/BuyLog/QueryPage',data)
}

//我的众筹
export const myCrowdFunding=(data)=>{
	return get('V1/CrowdFunding/CrowdFundingProject/MyList',data)
}

// 活动沙龙列表
export const Activitys = (data) => {
	return get('/V1/Activity/Activity/QueryPage', data)
}
//活动沙龙详情
export const ActivityDetail = (data) => {
	return get('/V1/Activity/Activity/Detail', data)
}

// 申请报名
export const sign = (data) => {
	return post('/V1/Activity/Activity/Apply', data)
}

// 课程分类
export const CategoryClassification = (data) => {
	return get('/v1/Course/Category/Query', data)
}
// 课程列表
export const CategoryList = (data) => {
	return get('/v1/Course/Course/QueryPage', data)
}
//课程详情
export const ClassDetail = (data) => {
	return get('/v1/Course/Course/Detail', data)
}

//课程查看记录
export const ClassSee = (data) => {
	return get('/v1/Course/ViewLog/QueryPage', data)
}
//课程购买记录
export const ClassBuy = (data) => {
	return get('/v1/Course/Order/QueryPage', data)
}
//获取订单
export const orderAdd = (data) => {
	return post('/v1/Course/Order/Add', data)
}

//发起订单
export const orderPay = (data) => {
	return post('/V1/Pay/Add', data)
}

//联系我们
export const getcontact = (data) => {
	return get('/Member/V1/Setting/Contact', data)
}
// 意见反馈
export const feedback = (data) => {
	return post('/V1/Member/Feedback/Add', data)
}
//阿里oss上传
export const aliupload = (data) => {
	return get('/V1/Common/AliyunOSS/Sign', data)
}

// 退出登录
export const quitlogin = (data) => {
	return post('/V1/Member/Account/LoginOut', data)
}

// 底部页面数据
export const getOther = (data) => {
	return get('/V1/Website/Page/Detail', data)
}

//获取讲师信息
export const getLecturer = (data) => {
	return get('/v1/Course/Lecturer/Query', data)
}

export const demand = (data) => {
	return post('/v1/Demand/Add', data)
}

//解决方案资料相关接口
//获取资料分类
export const getType = (data) => {
	return get('/V1/Content/Document/Category', data)
}
//获取资料列表
export const getDatumList = (data) => {
	return get('/V1/Content/Document/QueryPage', data)
}
//查看资料详细
export const getDatumDetail = (data) => {
	return get('/V1/Content/Document/Detail', data)
}
//查看二维码
export const getQrcode = (data) => {
	return get('/V1/Content/Document/GetWeixinQrCode', data)
}
//资料收藏或取消
export const postDatumCollection = (data) => {
	return post('/V1/Content/Document/Collection', data)
}
//获取资料收藏列表
export const getDatumCollectionList=(data)=>{
	return get('/V1/Content/Document/CollectionQueryPage',data)
}

//考试相关接口
//获取题目
export const gettitle = (data) => {
	return get('/v1/Course/Exam/TestPaper', data)
}
//提交答案
export const subexam = (data) => {
	return post('/v1/Course/Exam/Submit', data,{'content-type': 'application/problem+json; charset=utf-8'},false)
}
//获取结果
export const lookexam = (data) => {
	return get('/v1/Course/Exam/Result', data)
}
//获取我的考试列表
export const getMyexam = (data) => {
	return get('/v1/Course/Exam/QueryByMy', data)
}

//获取我提交的需求
export const getMytDatumList = (data) =>{
	return get('/V1/Demand/QueryPage',data)
}

//获取我的证书列表
export const getMycertificate = (data) => {
	return get('/v1/Member/Certificate/Query', data)
}

//获取用户能下载的证书桂冠
export const getCertificateHonour= (data) => {
	return get('v1/Member/Certificate/Honour', data)
}

//竞赛
//获取竞赛分类
export const getCompetitionCatrgory = (data) => {
	return get('/v1/Competition/Competition/List', data)
}
//获取我参与的竞赛
export const getCompetitionList = (data) => {
	return get('/v1/Competition/Competition/MyList', data)
}
//提交作品
export const postCompetition = (data) => {
	return post('/v1/Competition/Competition/Submit', data)
}
//提交作品
export const postCompetitionAdd = (data) => {
	return post('/v1/Competition/Competition/Add', data)
}
//获取上传作品数据
export const getCompetitionDetail = (data) => {
	return get('/v1/Competition/Competition/SubmitDetail', data)
}
//上传作品数据
export const postCompetitionSubmit = (data) => {
	return post('/v1/Competition/Competition/Submit', data)
}
//当月获奖作品
export const getByDuringMonth = (data) => {
	return get('/v1/Competition/AwardVideo/QueryByDuringMonth', data)
}
//历史获奖作品
export const getAwardVideo = (data) => {
	return get('/v1/Competition/AwardVideo/QueryPage', data)
}
//查询获奖作品日期
export const getTimeAwardVideo = (data) => {
	return get('/v1/Competition/AwardVideo/QueryByData', data)
}


//志愿者
//列表
export const getVolunteerQuery = (data) => {
	return get('/V1/Member/Volunteer/Query', data)
}
//详情
export const getVolunteerDetail = (data) => {
	return get('/V1/Member/Volunteer/Detail', data)
}
//修改
export const getVolunteerEdit = (data) => {
	return post('/V1/Member/Volunteer/Edit', data)
}
//添加
export const getVolunteerAdd = (data) => {
	return post('/V1/Member/Volunteer/Add', data)
}
//上传文件
export const postFileUpload = (data,headers,joint) => {
	return post('/V1/Common/AliyunOSS/FileUpload', data,headers,joint)
}

//获取调研分类
export const getSurveyCategory = (data) => {
	return get('/V1/Survey/Category', data)
}

//获取调研列表
export const getSurveyQuery = (data) => {
	return get('/V1/Survey/Query', data)
}

//获取调研详情
export const getSurveyDetail = (data) => {
	return get('/V1/Survey/Detail', data)
}

//获取我的调研
export const getSurveyMyList = (data) => {
	return get('/V1/Survey/MyList', data)
}

//获取调研答案
export const getSurveyAnswer = (data) => {
	return get('/V1/Survey/Answer', data)
}

//提交调研答案
export const postSurvey = (data) => {
	return post('/V1/Survey/Submit', data)
}

// // 监控用户在线情况
// export const jkuser = (data) => {
// 	return post('/V1/Member/Online/Heartbeat', data)
// }

//项目发现
export const getCrowdFundingList = (data) => {
	return get('/v1/Crowd/CrowdProject/QueryPage', data)
}
//获取众筹分类列表
export const getCrowdFundingCategoryList = (data) => {
	return get('/v1/Crowd/CrowdProject/GetCategory', data)
}
//众筹详情
export const getCrowdFundingDetail = (data) => {
	return get('/v1/Crowd/CrowdProject/Detail', data)
}
//众筹评论列表
export const getCrowdFundingCommentList = (data) => {
	return get('/v1/Crowd/CrowdProject/CommentList', data)
}
//众筹支持者列表
export const getCrowdFundingPayList = (data) => {
	return get('/v1/Crowd/CrowdProject/PayList', data)
}
//众筹发表评论
export const postCommentAdd = (data) => {
	return post('/v1/Crowd/CrowdProject/CommentAdd', data)
}
//我的众筹
export const getCrowdFundingMyList = (data) => {
	return get('/v1/Crowd/CrowdProject/MyList', data)
}
//支持众筹
export const postCrowdFundingAdd = (data) => {
	return post('/v1/Crowd/CrowdProject/Add', data)
}
//收藏/取消众筹
export const postCrowdFundingStar = (data) => {
	return post('/v1/Crowd/CrowdProject/Star', data)
}
//活动列表
export const getActivityList = (data) => {
	return get('/v1/Activity/Activity/QueryPage', data)
}

//活动详情
export const getActivityDetail = (data) => {
	return get('/v1/Activity/Activity/Detail', data)
}

//活动报名
export const getActivityApply= (data) => {
	return get('/v1/Activity/Activity/ApplyList', data)
}

//活动详情
export const getActivityItemDetail = (data) => {
	return get('/v1/Activity/Activity/ItemDetail', data)
}


//活动详情
export const postActivityApply = (data) => {
	return post('/v1/Activity/Activity/Apply', data)
}

//活动接受邀请
export const postActivityGetInvite = (data) => {
	return post('/v1/Activity/Activity/GetInvite', data)
}
//点播平台列表
export const getVodTicket = (data) => {
	return get('/v1/Vod/VodTicket/QueryPage', data)
}
//点播平台详情
export const getVodTicketDetail = (data) => {
	return get('/v1/Vod/VodTicket/Detail', data)
}

//点播平台购买
export const postVodTicketAdd = (data) => {
	return post('/v1/Vod/VodTicket/Add', data)
}
//增加观看记录
export const postVodTicketWatchLog = (data) => {
	return post('/v1/Vod/VodTicket/WatchLog', data)
}

//获取展映基地，顶部轮播图
export const getShowingSiteBanner = (data) => {
	return get('/v1/Showing/Site/Slideshow', data)
}

//获取展映基地，列表
export const getShowingSiteList = (data) => {
	return get('/v1/Showing/Site/QueryPage', data)
}

//获取展映基地，详情
export const getShowingSiteDetail = (data) => {
	return get('/v1/Showing/Site/Detail', data)
}

//获取展映活动，列表
export const getShowingList = (data) => {
	return get('/v1/Showing/Activity/QueryPage', data)
}

//获取展映活动，详情
export const getShowingDetail = (data) => {
	return get('/v1/Showing/Activity/Detail', data)
}
//获取展映活动，购买
export const getShowingBuy = (data) => {
	return post('/v1/Showing/Activity/Buy', data)
}


//合作伙伴Parteners
export const getPartners = (data) => {
	return get('v1/Page/PagePartners/Query', data)
}


//Base64Upload
export const postBase64Upload = (data) => {
	return post('V1/Common/AliyunOSS/Base64Upload', data)
}

//获取微信登录二维码
export const getWxLoginQrcode = (data) => {
	return get('V1/Common/Weixin/LoginQrCode', data)
}
//PC端扫码登录回调
export const getWxScanLogin = (data) => {
	return post('V1/Member/Account/ScanLogin', data)
}

//获取10个热点新闻
export const getHotNews = (data) => {
	return get('V1/Content/News/HotArticle', data)
}

//获取人才分类
export const getTalentCategory = (data) => {
	return get('v1/Talent/Category/Query', data)
}

//影视精英列表
export const getTalentList = (data) => {
	return get('V1/Talent/Talent/QueryPage', data)
}

//人才详情
export const getTalentDetail = (data) => {
	return get('V1/Talent/Talent/Detail', data)
}


//获取国际销售代理分类
export const getTrailerCategory = (data) => {
	return get('v1/Preview/PreviewCategory/Query', data)
}

//国际销售代理列表
export const getTrailerList = (data) => {
	return get('V1/Preview/PreviewPreview/QueryPage', data)
}

//国际销售代理详情
export const getTrailerDetail = (data) => {
	return get('V1/Preview/PreviewPreview/Detail', data)
}


//翠麟云剧场 Banner列表
export const getCinemaBanner = (data) => {
	return get('V1/Website/Page/Banner', data)
}

//翠麟云剧场 搜索全部类型
export const getCinemaCategory = (data) => {
	return get('/V1/Movie/Category/Query', data)
}

//翠麟云剧场 搜索全部地区
export const getCinemaQueryAreas = (data) => {
	return get('/V1/Movie/Movie/QueryAreas', data)
}

//翠麟云剧场 搜索全部地区
export const getCinemaList = (data) => {
	return get('/V1/Movie/Movie/QueryPage', data)
}

//翠麟云剧场 搜索全部地区
export const getCinemaDetail = (data) => {
	return get('/V1/Movie/Movie/Detail', data)
}

//翠麟云剧场下单
export const payAddCinema = (data) => {
	return post('/V1/Movie/BuyLog/Add', data)
}

//翠麟云剧场，添加播放记录
export const AddPayCinema = (data) => {
	return post('/V1/Movie/Log/AddPay', data)
}

//特约摄影师加入
export const PhotographerApplyAdd = (data) => {
	return post('/V1/Photographer/Apply/Add', data)
}

//特约摄影师 查询加入情况
export const PhotographerApplyGet = (data) => {
	return get('/V1/Photographer/Apply/Get', data)
}

//特约摄影师 去支付
export const PhotographerApplyToPay = (data) => {
	return get('/V1/Photographer/Apply/ToPay', data)
}

//特约摄影师 延长认证时间
export const PhotographerApplyRenew = (data) => {
	return get('/V1/Photographer/Apply/Renew', data)
}